<template>
  <div class="wrap">
    <myHead nav="5"></myHead>
    <div class="main-content flex-sb">
        <conMenu menuTitle="招标采购" :current="s_type" :menuList="typeList" @handleMenuClick="handleMenuClick"></conMenu>
        <div class="content main">
          <div class="main-head">
            <i class="el-icon-menu"></i>
            下载中心
          </div>
          <div class="section-one">
            <ul class="content-list">
              <li v-for="(item,index) in project.list" :key="index">
                <a :title="item.name" href="javascript:;" class="flex-cb">
                  <span class="title">{{item.name}}</span>
                  <el-button class="download-btn" type="primary" plain size="mini">
                    <a :href="item.attach_file_info.xurl" :download="item.attach_file_info.name" target="_blank">下载</a>
                  </el-button>
                </a>
              </li>
              <el-empty v-if="project.list.length==0" description="暂无数据"></el-empty>
            </ul>
           <div class="page-bar fr" v-if="project.page.total>0">
             <el-pagination prev-text="上一页" next-text="下一页" background layout="prev, pager, next" :page-size="project.page.limit" :total="project.page.total" @current-change="handleCurrentChange">
             </el-pagination>
           </div>
          </div>
        </div>
    </div>
    <myFoot></myFoot>
  </div>
</template>
<!-- 下载中心 -->
<script>
  import Vue from 'vue';
  import myHead from '../../components/myHead/myhead';
  import myFoot from '../../components/myFoot/myfoot';
  import conMenu from '../../components/conMenu/conmenu';
  import common from '../../assets/js/utils/common';
  import {
    mapActions,
    mapState,
    mapMutations
  } from "vuex";
  
  export default {
    name: "download",
    data() {
      return {
        typeList: [],
        type:{},
        s_type: 0,
        id: 0,
        project: {
          page: {
            limit: 7,
            total: 0,
            pages: 1,
            current: 1
          },
          list: []
        },
        is_loading: false,
        show_detail: false,
        detail:{},
        next:{},
        prev:{},
      }
    },
    components: {
      myHead,
      myFoot,
      conMenu
    },
    mounted() {
      let s_type = this.$route.query.s_type
      let id = this.$route.query.id
      if(s_type){
        this.s_type = parseInt(s_type)
      }
      if(id){
        this.id = parseInt(id)
      }
    },
    computed: {

    },
    created() {
      this.getType()
    },
    watch: {
      s_type(val){
        if(val){
          this.getProjectList()
        }
      },
      id(val){
        if(val){
          this.showDetail(val)
        }
      }
    },
    methods: {
      ...mapActions({
        getProjectDownloadType: "index/getProjectDownloadType",
        getProjectDownloadIndex: "index/getProjectDownloadIndex",
      }),
      
      getType(){
        this.getProjectDownloadType({
          data:{},
          success:(res) => {
            if(res.code == 1){
              this.typeList = res.data.list
              if(!this.s_type){
                this.s_type = this.typeList[0].id
                this.type= this.typeList[0]
              }else{
                this.type = this.typeList.find(type => type.id == this.s_type)
              }
            }
          },
        })
      },
      getProjectList(){
        this.getProjectDownloadIndex({
          data:{
            s_type:this.s_type,
            page:this.project.page.current
          },
          success:(res) => {
            if(res.code == 1){
              this.project = res.data
            }
          },
        })
      },
      handleCurrentChange(current){
        this.project.page.current = current
        this.getProjectList()
      },
      handleMenuClick(row){
        this.$router.push({name:'download',query:{s_type:row.id}})
        this.project.page.current = 1
        this.id = 0
        this.type = row
        if(this.s_type == row.id){
           this.getProjectList()
        }else{
          this.s_type = row.id
        }
        this.show_detail = false
      },
      showDetail(id){
        this.$router.push({name:'download',query:{s_type:this.s_type,id:id}})
        var param = {id:id}
        if(this.is_loading) return
        this.is_loading = true
        this.show_detail = true
        this.getProjectDownloadDetail({data:param,success:(res) => {
          this.is_loading = false
          if(res.code == 1){
            this.detail = res.data.detail
            this.prev = res.data.prev.id?res.data.prev:{}
            this.next = res.data.next.id?res.data.next:{}
          }
        }})
      },
      download(item) { //下载文件
        let a = document.createElement('a')
        let url = item.attach_file_info.xurl
        fetch(url, {
          mode: 'no-cors'
        }).then(res => res.blob()).then(blob => {
          a.href = URL.createObjectURL(blob)
          a.download = item.attach_file_info.name
          a.click()
        })
      }
    }
    
  }
</script>

<style scoped>
  .main-content {
    position: relative;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    margin: 30px auto 0;
    width: 1200px;
  }
  
  .main-content .main {
    width: 922px;
    background: #fff;
  }

  .main-head {
      text-align: left;
      position: relative;
      padding: 0 20px;
      font-size: 20px;
      font-weight: 700;
      background: #f5fafc;
      color: #0080FF;
      height: 72px;
      line-height: 72px;
    }
  
    .main-head::before {
     /* content: '';
      position: relative;
      top: 3px;
      display: inline-block;
      width: 20px;
      height: 20px; */
      /* background: #4370ff; */
      /* background: url(../../assets/images/title-before.png); */
    }
  .main-content .main .section-one {
    padding: 16px 2px;
  }

  .main-content .main .section-one .content-list {
    min-height: 300px;
  }

  .main-content .main .section-one .content-list li {
    display: block;
    font-weight: 700;
    padding: 0 20px;
    border-bottom: 1px dashed rgba(0, 0, 0, .2);
  }

  .main-content .main .section-one .content-list li>a {
    display: inline-flex;
    width: 100%;
    line-height: 55px;
    position: relative;
  }

  .main-content .main .section-one .content-list li>a:hover {
    color: #0080FF;
  }

  .main-content .main .section-one .content-list li .title {
    width: 100%;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .main-content .main .section-one .content-list li .download-btn {
    position: absolute;
    right: 0;
  }

  .main-content .main .section-one .page-bar {
    position: relative;
    margin: 20px 0 20px;
    height: 32px;
  }


  /deep/.el-pagination button,
  .el-pagination span:not([class*=suffix]) {
    padding: 0 6px !important;
  }

  /deep/.el-pagination button:hover,
  .el-pagination span:hover {
    color: #c74444 !important;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #0080FF;
  }
  /deep/.el-button--primary.is-plain{
    background-color: rgba(167, 18, 18,0.1);
    color: #0080FF;
    border: 1px solid #0080FF;
  }
    /deep/.el-button--primary.is-plain:hover{
      background-color: #a71212;
      color: #fff;
    }
</style>
